import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import DateFilter from '../common/dateFilter';
import strings from '../locales/';

const Header = props =>
  !props.loadingFilter ? (
    <div className="header">
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.filter.from}</label>
        </div>
        <div>
          <DateFilter
            date={props.filters.date.fechaStartFinal ? 
              props.filters.date.fechaStartFinal : props.datos.fromDate.substring(0, 10)}
            dif={0}
            id="date-start"
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.filter.to}</label>
        </div>
        <div>
          <DateFilter
            date={props.filters.date.fechaEndFinal ? 
              props.filters.date.fechaEndFinal : props.datos.toDate.substring(0, 10)}
            dif={0}
            id="date-end"
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
      <div className={"box-form"}>
        <div className={'normal_button'} onClick={props.handleDownload}>
          <div>{"Exportar a excel"}</div>
        </div>
      </div>
    </div>
  ) : (
    <div className="header" />
  );

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/flows_history/header.jsx